<div class="overlay" *ngIf="isLoading | async">
  <div class="spinner">
    <div class="spinner-part spinner-part1"></div>
    <div class="spinner-part spinner-part2"></div>
    <img src="/assets/images/motorbike.png" alt="Suzuki Bike" class="spinner-center">
  </div>
</div>
<div class="container-fluid pl-0">
  <div class="container-inner">
    <div [hidden]="isCreate || isEdit || isOutletVerification">
      <div class="header-container">
        <h2>Outlet</h2>
        <div class="search-and-filter-container">
          <div class="search-container">
            <input type="text" [formControl]="searchInput" placeholder="Search..." (input)="applyFilter()"
              class="form-control" />
            <span class="clear-icon" *ngIf="searchInput.value" (click)="clearSearch()">&times;</span>
          </div>
          <div class="status-filter-container">
            <select [formControl]="statusFilter" class="form-select status-select">
              <option value="All">All</option>
              <option value="1">New</option>
              <option value="2">Terminated</option>
            </select>
          </div>
        </div>
        <div class="button-container">
          <button mat-raised-button class="add-button mr-1" (click)="export()"> Export</button>
          <button mat-raised-button class="add-button mr-1" (click)="goToImport()"><img class="upload-img"
              src="/assets/images/upload.png" alt=""> Import</button>
          <button mat-raised-button class="add-button" (click)="add()">Add Outlet</button>
        </div>
      </div>
      <div class="leads-table mb-3">
        <table mat-table [dataSource]="dataSource" matSort class="mat-table">
          <ng-container matColumnDef="SNo">
            <th mat-header-cell *matHeaderCellDef> S.No </th>
            <td mat-cell *matCellDef="let element; let i = index"> {{ (paginatorRef.pageIndex *
              paginatorRef.pageSize) + (i + 1) }}</td>
          </ng-container>

          <ng-container matColumnDef="outlet_name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Outlet Name</th>
            <td mat-cell *matCellDef="let element">{{element.outlet_name}}</td>
          </ng-container>

          <ng-container matColumnDef="outlet_code">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Outlet Code</th>
            <td mat-cell *matCellDef="let element">{{element.outlet_code}}</td>
          </ng-container>

          <ng-container matColumnDef="outlet_for_code">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Outlet for Code</th>
            <td mat-cell *matCellDef="let element">{{element.outlet_for_code}}</td>
          </ng-container>
          <ng-container matColumnDef="outlet_map_code">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Outlet Map Code</th>
            <td mat-cell *matCellDef="let element">{{element.outlet_map_code}}</td>
          </ng-container>

          <ng-container matColumnDef="parent_dealer_name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Parent Dealer</th>
            <td mat-cell *matCellDef="let element">{{element.parent_dealer_name}}</td>
          </ng-container>




          <ng-container matColumnDef="trade_name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Trade Name</th>
            <td mat-cell *matCellDef="let element">{{element.trade_name}}</td>
          </ng-container>

          <ng-container matColumnDef="date_of_inauguration">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Date of Termination</th>
            <td mat-cell *matCellDef="let element">{{element.msil_termination_date | date:'dd/MM/yyyy'}}</td>
          </ng-container>

          <ng-container matColumnDef="contact_person">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Contact Person</th>
            <td mat-cell *matCellDef="let element">{{element.contact_person}}</td>
          </ng-container>

          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
            <td mat-cell *matCellDef="let element"
              [ngClass]="element.status == 1 ? 'status_active' : 'status_inactive'">
              {{element.status ? 'Active' : 'In-Active'}}</td>
          </ng-container>

          <! Action Column>
            <ng-container matColumnDef="action">
              <th mat-header-cell *matHeaderCellDef style="text-align: center;">Action</th>
              <td mat-cell *matCellDef="let element" style="text-align: center;">
                <img [src]="bucketurl + '/images/pen.png'" class="edit-pen" title="Edit" (click)="editData(element)">
                <img [src]="bucketurl + '/images/verified-profile.png'" class="edit-view"
                  style="width: 30px; margin-left: 6px;" title="View" (click)="viewUserData(element)">
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            <tr class="mat-row" *matNoDataRow>
              <td class="mat-cell" style="text-align: center;padding: 20px 0;" colspan="8">No data found!
              </td>
            </tr>
        </table>

        <mat-paginator #paginatorRef [pageSizeOptions]="[10, 20]" showFirstLastButtons></mat-paginator>
      </div>
    </div>
    <ng-container *ngIf="isCreate || isEdit && !isOutletVerification">
      <div class="header-container">
        <h2>Outlet</h2>
        <div class="button-container">
          <button mat-raised-button class="add-button" (click)="back()">Back to List</button>
        </div>
      </div>
      <form [formGroup]="outletForm">
        <div class="row">
          <div class="row">

            <div class="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 mt-2">
              <div class="themeinput">
                <label>Outlet Name</label><span style="color: red; font-size :15px">&nbsp;*</span>
                <input type="text" class="form-control" placeholder="Outlet Name" formControlName="outletName"
                  maxlength="250" [ngClass]="{ 'is-invalid': submitted && f['outletName'].errors }" />
                <div *ngIf="submitted && f['outletName'].errors" class="invalid-feedback">
                  <div *ngIf="f['outletName'].errors['required']">
                    Outlet Name is required
                  </div>
                </div>
              </div>
            </div>

            <div class="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 mt-2">
              <div class="themeinput">
                <label>Outlet Code</label><span style="color: red; font-size :15px">&nbsp;*</span>
                <input type="text" class="form-control" placeholder="Outlet Code" formControlName="outletCode"
                  maxlength="6" minlength="6" [ngClass]="{ 'is-invalid': submitted && f['outletCode'].errors }"
                  (keypress)="allowNumbersOnly($event)" />
                <div *ngIf="submitted && f['outletCode'].errors" class="invalid-feedback">
                  <div *ngIf="f['outletCode'].errors['required']">
                    Outlet Code is required
                  </div>
                  <div *ngIf="f['outletCode'].errors['minlength']">
                    Outlet Code must be 6 digits
                  </div>
                </div>
              </div>
            </div>

            <div class="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 mt-2">
              <div class="themeinput">
                <label>Location Code</label><span style="color: red; font-size :15px">&nbsp;*</span>
                <input type="text" class="form-control" placeholder="Location Code" formControlName="locationCode"
                  maxlength="6" [ngClass]="{ 'is-invalid': submitted && f['locationCode'].errors }" />
                <div *ngIf="submitted && f['locationCode'].errors" class="invalid-feedback">
                  <div *ngIf="f['locationCode'].errors['required']">
                    Location Code is required
                  </div>

                </div>
              </div>
            </div>

            <div class="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 mt-2">
              <div class="themeinput">
                <label>Parent Dealer</label><span style="color: red; font-size :15px">&nbsp;*</span>
                <ng-multiselect-dropdown [placeholder]="'Select Dealer'" formControlName="parentDealer"
                  class="form-control singleselect" [settings]="dropdownSettingsDealer" [data]="parentDealerList"
                  [ngClass]="{ 'is-invalid': submitted && f['parentDealer'].errors }"
                  (onSelect)="onDealerSelect($event)" (onDeSelect)="onDealerDeSelect($event)">
                </ng-multiselect-dropdown>
                <div *ngIf="submitted && f['parentDealer'].errors" class="invalid-feedback">
                  <div *ngIf="f['parentDealer'].errors['required']">
                    Parent Dealer is required
                  </div>
                </div>
              </div>
            </div>
          </div>


          <div class="row mt-3">
            <!-- <div class="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 mt-2">
              <div class="themeinput">
                <label>District</label>
                <select name="" class="form-select" formControlName="district" (change)="getAreaList()"
                  [ngClass]="{ 'is-invalid': submitted && f['district'].errors }">
                  <option value="" disabled selected>--Select District--</option>
                  <option [value]="data.id" *ngFor="let data of districtList">{{data.district_name}}</option>
                </select>
                <div *ngIf="submitted && f['district'].errors" class="invalid-feedback">
                  <div *ngIf="f['district'].errors['required']">District is required</div>
                </div>
              </div>
            </div>
            <div class="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 mt-2">
              <div class="themeinput">
                <label>Area</label>
                <select name="" class="form-select" formControlName="area"
                  [ngClass]="{ 'is-invalid': submitted && f['area'].errors }">
                  <option value="" disabled selected>--Select Area--</option>
                  <option [value]="data.id" *ngFor="let data of areaList">{{data.area_name}}</option>
                </select>
                <div *ngIf="submitted && f['area'].errors" class="invalid-feedback">
                  <div *ngIf="f['area'].errors['required']">Area is required</div>
                </div>
              </div>
            </div> -->
            <div class="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 mt-2">
              <div class="themeinput">
                <label>City CD</label><span style="color: red; font-size :15px">&nbsp;*</span>
                <input type="text" class="form-control" placeholder="City CD" formControlName="city_cd"
                  maxlength="6"  [ngClass]="{ 'is-invalid': submitted && f['city_cd'].errors }"
                   />
                <div *ngIf="submitted && f['city_cd'].errors" class="invalid-feedback">
                  <div *ngIf="f['city_cd'].errors['required']">
                    City CD is required
                  </div>
                  
                </div>
              </div>
            </div>

            <div class="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 mt-2">
              <div class="themeinput">
                <label>City Name</label><span style="color: red; font-size :15px">&nbsp;*</span>
                <input type="text" class="form-control" placeholder="City Name" formControlName="cityName"
                  maxlength="100"  [ngClass]="{ 'is-invalid': submitted && f['cityName'].errors }"/>
                <div *ngIf="submitted && f['cityName'].errors" class="invalid-feedback">
                  <div *ngIf="f['cityName'].errors['required']">
                    City Name is required
                  </div>
                 
                </div>
              </div>
            </div>
            <div class="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 mt-2">
              <div class="themeinput">
                <label>Trade Name</label>
                <input type="text" class="form-control" placeholder="Trade Name" formControlName="tradeName"
                  maxlength="150" />
                <!-- <div *ngIf="submitted && f['tradeName'].errors" class="invalid-feedback">
                  <div *ngIf="f['tradeName'].errors['required']">
                    Trade Name is required
                  </div>
                </div> -->
              </div>
            </div>
            <div class="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 mt-2">
              <div class="themeinput">
                <label>Date of Inaguration</label>
                <input readonly class="form-control" style="cursor: pointer;" (click)="picker.open()"
                  [matDatepicker]="picker" formControlName="dataOfInauguration">
                <mat-datepicker #picker></mat-datepicker>
              </div>
            </div>



          </div>
          <div class="row mt-3">
            <div class="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 mt-2">
              <div class="themeinput">
                <label>Dealership Type</label><span style="color: red; font-size :15px">&nbsp;*</span>
                <select name="" class="form-select" formControlName="dealershipType"
                  [ngClass]="{ 'is-invalid': submitted && f['dealershipType'].errors }">
                  <option value="" disabled selected>Select Dealership Type</option>
                  <option [value]="data.id" *ngFor="let data of dealershipTypeList">{{data.name}}</option>
                </select>
                <div *ngIf="submitted && f['dealershipType'].errors" class="invalid-feedback">
                  <div *ngIf="f['dealershipType'].errors['required']">Dealership Type is required</div>
                </div>
              </div>
            </div>

            <div class="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 mt-2">
              <div class="themeinput">
                <label>Product Category</label><span style="color: red; font-size :15px">&nbsp;*</span>
                <ng-multiselect-dropdown [placeholder]="'Select Product Category'" formControlName="productCategory"
                  class="form-control" [settings]="dropdownSettingsProCategory" [data]="productCategoryList"
                  [ngClass]="{ 'is-invalid': submitted && f['productCategory'].errors }">
                </ng-multiselect-dropdown>
                <div *ngIf="submitted && f['productCategory'].errors" class="invalid-feedback">
                  <div *ngIf="f['productCategory'].errors['required']">Product Category is required</div>
                </div>
              </div>
            </div>
            <div class="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 mt-2">
              <div class="themeinput">
                <label>Contact Person Name</label>
                <input type="text" class="form-control" placeholder="Contact person name"
                  formControlName="contactPersonName" maxlength="150" />
              </div>
            </div>

            <div class="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 mt-2">
              <div class="themeinput">
                <label>Contact Person No</label>
                <input type="text" class="form-control" placeholder="Contact person no"
                  formControlName="contactPersonNumber" maxlength="10" (keypress)="allowNumbersOnly($event)" />
              </div>
            </div>



          </div>

          <div class="row mt-3">


            <div class="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 mt-2">
              <div class="themeinput">
                <label>Contact Person Alternate No</label>
                <input type="text" class="form-control" placeholder="Contact Person Alternate No"
                  (keypress)="allowNumbersOnly($event)" formControlName="contactPersonNumberAlt" maxlength="10" />
              </div>
            </div>
            <div class="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 mt-2">
              <div class="themeinput">
                <label>Contact Person Email ID</label><span style="color: red; font-size :15px">&nbsp;*</span>
                <input type="text" class="form-control" placeholder="Contact Person Email"
                  formControlName="contactPersonEmail" maxlength="150"
                  [ngClass]="{ 'is-invalid': submitted && f['contactPersonEmail'].errors }" />
                <div *ngIf="submitted && f['contactPersonEmail'].errors" class="invalid-feedback">
                  <div *ngIf="f['contactPersonEmail'].errors['required']">
                    Contact Person Email ID is required
                  </div>
                  <div *ngIf="f['contactPersonEmail'].errors['pattern']">
                    Email ID is not valid
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 mt-2">
              <div class="themeinput">
                <label>Email ID CEO</label>
                <input type="text" class="form-control" placeholder="Email ID CEO" formControlName="emailIdCeo"
                  maxlength="150" />
              </div>
            </div>
            <div class="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 mt-2">
              <div class="themeinput">
                <label>Email ID Sales</label>
                <input type="text" class="form-control" placeholder="Email ID Sales" formControlName="emailIdSales"
                  maxlength="150" />
              </div>
            </div>






          </div>

          <div class="row mt-3">
            <div class="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 mt-2">
              <div class="themeinput">
                <label>Email ID Service</label>
                <input type="text" class="form-control" placeholder="Email ID Service" formControlName="emailIdService"
                  maxlength="150" [ngClass]="{ 'is-invalid': submitted && f['emailIdService'].errors }" />
                <div *ngIf="submitted && f['emailIdService'].errors" class="invalid-feedback">
                  <div *ngIf="f['emailIdService'].errors['required']">
                    Email ID Service is required
                  </div>
                  <div *ngIf="f['emailIdService'].errors['pattern']">
                    Email ID is not valid
                  </div>
                </div>
              </div>
            </div>

            <div class="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 mt-2">
              <div class="themeinput">
                <label>Email ID Spares</label>
                <input type="text" class="form-control" placeholder="Email ID Spares" formControlName="emailIdSpares"
                  maxlength="150" [ngClass]="{ 'is-invalid': submitted && f['emailIdSpares'].errors }" />
                <div *ngIf="submitted && f['emailIdSpares'].errors" class="invalid-feedback">
                  <div *ngIf="f['emailIdSpares'].errors['required']">
                    Email ID Spares is required
                  </div>
                  <div *ngIf="f['emailIdSpares'].errors['pattern']">
                    Email ID is not valid
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 mt-2">
              <div class="themeinput">
                <label>Alternate Email ID </label>
                <input type="text" class="form-control" placeholder="Alternate Email ID"
                  formControlName="alternateEmailId" maxlength="150"
                  [ngClass]="{ 'is-invalid': submitted && f['alternateEmailId'].errors }" />
                <div *ngIf="submitted && f['alternateEmailId'].errors" class="invalid-feedback">
                  <div *ngIf="f['alternateEmailId'].errors['required']">
                    Alternate Email ID is required
                  </div>
                  <div *ngIf="f['alternateEmailId'].errors['pattern']">
                    Email ID is not valid
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 mt-2">
              <div class="themeinput">
                <label>Non Sales Others Email ID </label>
                <input type="text" class="form-control" placeholder="Non Sales Email ID"
                  formControlName="emailIdNonSales" maxlength="150"
                  [ngClass]="{ 'is-invalid': submitted && f['emailIdNonSales'].errors }" />
                <div *ngIf="submitted && f['emailIdNonSales'].errors" class="invalid-feedback">
                  <div *ngIf="f['emailIdNonSales'].errors['required']">
                    Non Sales Email ID is required
                  </div>
                  <div *ngIf="f['emailIdNonSales'].errors['pattern']">
                    Email ID is not valid
                  </div>
                </div>
              </div>
            </div>



          </div>
          <div class="row mt-3">
            <div class="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 mt-2">
              <div class="themeinput">
                <label>Outlet For Code </label><span style="color: red; font-size :15px">&nbsp;*</span>
                <input type="text" class="form-control" placeholder="Outlet for Code" formControlName="outLetForCode"
                  [ngClass]="{ 'is-invalid': submitted && f['outLetForCode'].errors }" />
                <div *ngIf="submitted && f['outLetForCode'].errors" class="invalid-feedback">
                  <div *ngIf="f['outLetForCode'].errors['required']">
                    Outlet for Code is required
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 mt-2">
              <div class="themeinput">
                <label>Outlet Map Code </label><span style="color: red; font-size :15px">&nbsp;*</span>
                <input type="number" class="form-control" placeholder="Outlet Map Code" formControlName="outLetMapCode"
                  [ngClass]="{ 'is-invalid': submitted && f['outLetMapCode'].errors }" />
                <div *ngIf="submitted && f['outLetMapCode'].errors" class="invalid-feedback">
                  <div *ngIf="f['outLetMapCode'].errors['required']">
                    Outlet Map Code is required
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 mt-2">
              <div class="themeinput">
                <label>Non Sales Insurance Email ID </label>
                <input type="text" class="form-control" placeholder="Non Sales Insurance Email ID"
                  formControlName="non_sales_insurance_email" maxlength="150"
                  [ngClass]="{ 'is-invalid': submitted && f['non_sales_insurance_email'].errors }" />
                <div *ngIf="submitted && f['non_sales_insurance_email'].errors" class="invalid-feedback">
                  <div *ngIf="f['non_sales_insurance_email'].errors['required']">
                    Non Sales Insurance Email ID is required
                  </div>
                  <div *ngIf="f['non_sales_insurance_email'].errors['pattern']">
                    Email ID is not valid
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 mt-2">
              <div class="themeinput">
                <label>Non Sales Finance Email ID </label>
                <input type="text" class="form-control" placeholder="Non Sales Finance Email ID"
                  formControlName="non_sales_finance_email" maxlength="150"
                  [ngClass]="{ 'is-invalid': submitted && f['non_sales_finance_email'].errors }" />
                <div *ngIf="submitted && f['non_sales_finance_email'].errors" class="invalid-feedback">
                  <div *ngIf="f['non_sales_finance_email'].errors['required']">
                    Non Sales Finance Email ID is required
                  </div>
                  <div *ngIf="f['non_sales_finance_email'].errors['pattern']">
                    Email ID is not valid
                  </div>
                </div>
              </div>
            </div>


          </div>
          <div class="row mt-3">
            <div class="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 mt-2">
              <div class="themeinput">
                <label>Non Sales Best Value Email ID </label>
                <input type="text" class="form-control" placeholder="Non Sales Best value Email ID"
                  formControlName="non_sales_bestvalue_email" maxlength="150"
                  [ngClass]="{ 'is-invalid': submitted && f['non_sales_bestvalue_email'].errors }" />
                <div *ngIf="submitted && f['non_sales_bestvalue_email'].errors" class="invalid-feedback">
                  <div *ngIf="f['non_sales_bestvalue_email'].errors['required']">
                    Non Sales Best Value Email ID is required
                  </div>
                  <div *ngIf="f['non_sales_bestvalue_email'].errors['pattern']">
                    Email ID is not valid
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 mt-2">
              <div class="themeinput">
                <label>Non Sales Accessories Email ID </label>
                <input type="text" class="form-control" placeholder="Non Sales Accessories Email ID"
                  formControlName="non_sales_accessories_email" maxlength="150"
                  [ngClass]="{ 'is-invalid': submitted && f['non_sales_accessories_email'].errors }" />
                <div *ngIf="submitted && f['non_sales_accessories_email'].errors" class="invalid-feedback">
                  <div *ngIf="f['non_sales_accessories_email'].errors['required']">
                    Non Sales Accessories Email ID is required
                  </div>
                  <div *ngIf="f['non_sales_accessories_email'].errors['pattern']">
                    Email ID is not valid
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 mt-2">
              <div class="themeinput">
                <label>Non Sales Service Info Email ID </label>
                <input type="text" class="form-control" placeholder="Non Sales Service Info Email ID"
                  formControlName="non_sales_service_info_email" maxlength="150"
                  [ngClass]="{ 'is-invalid': submitted && f['non_sales_service_info_email'].errors }" />
                <div *ngIf="submitted && f['non_sales_service_info_email'].errors" class="invalid-feedback">
                  <div *ngIf="f['non_sales_service_info_email'].errors['required']">
                    Non Sales Service Info Email ID is required
                  </div>
                  <div *ngIf="f['non_sales_service_info_email'].errors['pattern']">
                    Email ID is not valid
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 mt-2">
              <div class="themeinput">
                <label>P & S Email ID:</label>
                <input type="email" class="form-control" placeholder="" formControlName="p_s_email"
                  [ngClass]="{ 'is-invalid': submitted && f['p_s_email'].errors }" />
                <div *ngIf="submitted && f['p_s_email'].errors" class="invalid-feedback">
                  <div *ngIf="f['p_s_email'].errors['pattern']">Enter a valid email address</div>
                </div>
              </div>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 mt-2">
              <div class="themeinput">
                <label>Working Hours From:</label>
                <input type="text" class="form-control" placeholder="" formControlName="working_hour_from"
                  [ngClass]="{ 'is-invalid': submitted && f['working_hour_from'].errors }" default="" />
                <div *ngIf="submitted && f['working_hour_from'].errors" class="invalid-feedback">
                  <div *ngIf="f['working_hour_from'].errors['pattern']">Enter a valid email address</div>
                </div>
              </div>
            </div>
            <div class="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 mt-2">
              <div class="themeinput">
                <label>Working Hours To:</label>
                <input type="text" class="form-control" placeholder="" formControlName="working_hour_to"
                  [ngClass]="{ 'is-invalid': submitted && f['working_hour_to'].errors }" />
                <div *ngIf="submitted && f['working_hour_to'].errors" class="invalid-feedback">
                  <div *ngIf="f['working_hour_to'].errors['pattern']">Enter a valid email address</div>
                </div>
              </div>
            </div>
            <div class="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 mt-2">
              <div class="themeinput">
                <label>Shop Address </label>
                <textarea type="text" class="form-control" placeholder="Shop Address"
                  formControlName="shopAddress"></textarea>
              </div>
            </div>

            <div class="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 mt-2">
              <div class="themeinput">
                <label>Status</label><span style="color: red; font-size :15px">&nbsp;*</span>
                <select name="" class="form-select" formControlName="status"
                  [ngClass]="{ 'is-invalid': submitted && f['status'].errors }">
                  <option value="" disabled selected>Select Status</option>
                  <option value="1">Active</option>
                  <option value="0">In-Active</option>
                </select>
                <div *ngIf="submitted && f['status'].errors" class="invalid-feedback">
                  <div *ngIf="f['status'].errors['required']">Status is required</div>
                </div>
              </div>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-12 mt-3">
              <div class="form-check mt-3">
                <input type="checkbox" class="form-check-input large-checkbox" id="is_verified"
                  formControlName="is_verified" style="border: 1px solid #030303; ">

                <label class="form-check-label" for="is_verified" style="color: #333;">
                  I confirm that I have checked and verified the Outlet information.
                </label>
              </div>
            </div>
          </div>
          <div class="col-lg-12 mt-5">
            <div class="text-right-right">
              <button *ngIf="isCreate" mat-raised-button class="clear-button" (click)="clearForm()">Clear</button>
              <button *ngIf="isCreate" class="create-button ml-2" mat-raised-button (click)="create()">Create</button>
              <button *ngIf="isEdit" class="create-button ml-2" mat-raised-button (click)="update()">Update</button>
            </div>
          </div>
        </div>
      </form>
    </ng-container>

    <ng-container *ngIf="isOutletVerification">
      <div class="header-container">
        <h2>Outlet Verified By</h2>
        <div class="button-container">
          <button mat-raised-button class="add-button" (click)="back()">
            Back to List
          </button>
        </div>
      </div>

      <div class="leads-table mb-3">
        <table mat-table [dataSource]="verificationDataSource" matSort class="mat-table">

          <!-- S.No -->
          <ng-container matColumnDef="SNo">
            <th mat-header-cell *matHeaderCellDef>S.No</th>
            <td mat-cell *matCellDef="let element; let i = index">
              {{ (verificationPaginator.pageIndex * verificationPaginator.pageSize) + (i + 1) }}
            </td>
          </ng-container>


          <!-- Outlet Name -->
          <ng-container matColumnDef="username">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              Username
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.username }}
            </td>
          </ng-container>

          <!-- Outlet Code -->
          <ng-container matColumnDef="createdAt">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              Verified Date
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.createdAt }}
            </td>
          </ng-container>

          <!-- IP Adress -->
          <ng-container matColumnDef="ip_address">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              IP Address
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.ip_address }}
            </td>
          </ng-container>

          <!-- Outlet Map Code -->
          <!--<ng-container matColumnDef="outlet_map_code">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              Outlet Map Code
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.outlet_map_code }}
            </td>
          </ng-container> -->

          <tr mat-header-row *matHeaderRowDef="verificationDisplayedColumns; sticky: true">
          </tr>

          <tr mat-row *matRowDef="let row; columns: verificationDisplayedColumns;">
          </tr>

          <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell text-center p-3" colspan="5">
              No data found!
            </td>
          </tr>
        </table>

        <mat-paginator #verificationPaginator [pageSizeOptions]="[10, 20]" showFirstLastButtons>
        </mat-paginator>
      </div>
    </ng-container>
  </div>
</div>